import api from './api';

const partnerService = {
  /**
   * Get partner dashboard data
   */
  async getDashboard() {
    const response = await api.get('/partners/dashboard');
    return response.data;
  },

  /**
   * Get partner profile
   */
  async getProfile() {
    const response = await api.get('/partners/profile');
    return response.data;
  },

  /**
   * Update partner profile
   */
  async updateProfile(data) {
    const response = await api.put('/partners/profile', data);
    return response.data;
  },

  /**
   * Get partner stats
   */
  async getStats(period = 'month') {
    const response = await api.get('/partners/stats', { params: { period } });
    return response.data;
  },

  /**
   * Update payment info
   */
  async updatePaymentInfo(data) {
    const response = await api.put('/partners/payment-info', data);
    return response.data;
  },

  /**
   * Get team members
   */
  async getTeamMembers() {
    const response = await api.get('/partners/team');
    return response.data;
  },

  /**
   * Add team member
   */
  async addTeamMember(data) {
    const response = await api.post('/partners/team', data);
    return response.data;
  },

  /**
   * Remove team member
   */
  async removeTeamMember(userId) {
    const response = await api.delete(`/partners/team/${userId}`);
    return response.data;
  },

  /**
   * Update team member role
   */
  async updateTeamMemberRole(userId, role) {
    const response = await api.put(`/partners/team/${userId}`, { role });
    return response.data;
  },

  /**
   * Get partner resources (marketing, training, etc.)
   */
  async getResources(params = {}) {
    const response = await api.get('/partners/resources', { params });
    return response.data;
  },

  /**
   * Get partner activity logs
   */
  async getActivity() {
    const response = await api.get('/partners/activity');
    return response.data;
  }
};

export default partnerService;

